<div class="device-list-result">
  <ui-device-list
    [items]="rows()"
    [getItemKey]="rowKey"
    [estimateSize]="estimateRowSize"
    [itemTemplate]="rowTemplate"
    [paddingEnd]="selectedCount() ? 96 : 0"
  >
    <ng-template #rowTemplate let-row let-index="index">
      @switch (row.type) {
        @case ('location') {
          <div class="device-list-location-shell" [style.padding-top.px]="locationPaddingTop(row, index)">
            <div
              class="device-list-location"
              [class.expanded]="isExpanded(row.location.id)"
              [class.expandable]="locationDeviceCount(row.location) > 0"
              [style.--depth]="row.depth"
              (click)="toggleLocation(row.location)"
            >
              <div class="grid">
                <div class="table-row device-list-location__grid">
                  <div class="flex-row start-center gap-8">
                    <mat-checkbox
                      (change)="selectLocation(row.location, $event)"
                      (click)="$event.stopPropagation()"
                      [checked]="isLocationSelected(row.location)"
                      [indeterminate]="isLocationIndeterminate(row.location)"
                      [style.opacity]="locationCameras(row.location).length ? 1 : 0"
                    ></mat-checkbox>
                    <span class="ui-icon-location"></span>
                    <span class="truncate">
                      {{ row.location.name || 'Untitled location' }}
                      @if (row.location.address) {
                        <span class="dot">&middot;</span>
                        {{ row.location.address }}
                      }
                    </span>
                  </div>
                  <div>
                    <span class="badge">{{ locationDeviceCount(row.location) }}</span>
                  </div>
                  <div class="flex-row gap-20 start-center">
                    @if (locationDeviceCount(row.location)) {
                      <div class="flex-row gap-6 start-center">
                        <span class="ui-icon-status-online"></span>
                        <span class="status-counter">{{ statusCount(row.location, 'online') }}</span>
                      </div>
                      <div class="flex-row gap-6 start-center">
                        <span class="ui-icon-status-unhealthy"></span>
                        <span class="status-counter">{{ statusCount(row.location, 'unhealthy') }}</span>
                      </div>
                      <div class="flex-row gap-6 start-center">
                        <span class="ui-icon-status-offline"></span>
                        <span class="status-counter">{{ statusCount(row.location, 'offline') }}</span>
                      </div>
                    }
                  </div>
                  <div></div>
                  <div class="flex-row end-center">
                    @if (locationDeviceCount(row.location)) {
                      <span
                        class="ui-icon-expand-arrow p-8"
                        [class.open]="isExpanded(row.location.id)"
                      ></span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        @case ('section-header') {
          <div class="device-list-child device-list-child--header" [style.--depth]="row.depth">
            <div class="grid">
              <div class="header table-row device-list-table-grid">
                <div><div class="flex-row start-center"><span class="type-space"></span>Type</div></div>
                <div><div class="truncate">Name</div></div>
                <div><div class="truncate">Status</div></div>
                <div><div class="truncate">Devices</div></div>
                <div><div class="truncate">IP Address</div></div>
                <div><div class="truncate">MAC Address</div></div>
                <div><div class="truncate">ID</div></div>
                <div><div class="truncate">Tags</div></div>
                <div><div class="truncate">Issues</div></div>
                <div><div class="truncate">Local</div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        }

        @case ('device') {
          <div
            class="device-list-child device-list-device"
            [class.device-list-child--last]="row.last"
            [style.--depth]="row.depth"
          >
            <div class="grid">
              <div
                class="table-row device-list-table-grid"
                [class.selected]="isCameraSelected(row.device.id)"
              >
                <div>
                  <div class="flex-row gap-16 start-center">
                    @if (row.device.type === 'camera') {
                      <mat-checkbox
                        (change)="selectCamera(row.device.id, $event)"
                        (click)="$event.stopPropagation()"
                        [checked]="isCameraSelected(row.device.id)"
                      ></mat-checkbox>
                      <ui-camera-status-snapshot
                        [cameraId]="row.device.id"
                        [iconSizePx]="20"
                        [showStatus]="false"
                      ></ui-camera-status-snapshot>
                    } @else {
                      <span class="device-leading-space"></span>
                      <img class="device-image" [src]="deviceImage(row.device)" alt="" />
                    }
                  </div>
                </div>
                <div><div class="truncate">{{ row.device.name }}</div></div>
                <div>
                  @if (statusIconClass(row.device)) {
                    <span [class]="statusIconClass(row.device)" [attr.aria-label]="row.device.status"></span>
                  } @else {
                    <span class="no-data">—</span>
                  }
                </div>
                <div>
                  @if (row.device.type === 'camera') {
                    <div class="flex-row start-center gap-6 active-link truncate">
                      <span class="ui-icon-edge-status-alert"></span>
                      <span class="truncate">{{ coreName(row.device) }}</span>
                    </div>
                  } @else if (row.device.type === 'core') {
                    <div class="flex-row start-center gap-6 active-link">
                      <span class="ui-icon-camera"></span>
                      <span>{{ row.device.connectedDeviceCount ?? 0 }}</span>
                    </div>
                  }
                </div>
                <div><div class="truncate">{{ row.device.ipAddress || row.device.host || '—' }}</div></div>
                <div><div class="truncate">{{ row.device.macAddress || '—' }}</div></div>
                <div><div class="truncate">{{ row.device.id }}</div></div>
                <div><div class="truncate">{{ row.device.tags.join(', ') }}</div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        }
      }
    </ng-template>
  </ui-device-list>

  @if (selectedCount()) {
    <div class="camera-selection flex-row start-center">
      <div class="camera-counter flex-row center-center">{{ selectedCount() }}</div>
      <div class="camera-actions flex-row start-center w-100 gap-8">
        <div class="selection-actions flex-row start-center gap-8">
          <ui-button type="noBorderPrimary" (clickAction)="selectAllCameras()">
            {{ 'COMMON.SELECT_ALL' | translate }}
          </ui-button>
          @if (enableChangePasswordFeature()) {
            <ui-button type="secondary" (clickAction)="changePasswordSelected()">
              <div class="flex-row start-center gap-8">
                <span class="ui-icon-key select-cameras-btn-icon"></span>
                {{ 'LOCATION_LIST.CHANGE_PASSWORD' | translate }}
              </div>
            </ui-button>
          }
          <ui-button type="secondary" (clickAction)="testSelected()">
            <div class="flex-row start-center gap-8">
              <span class="ui-icon-object-edge select-cameras-btn-icon"></span>
              {{ 'LOCATION_LIST.TEST_SELECTED' | translate }}
            </div>
          </ui-button>
          <ui-button type="secondary" (clickAction)="manageSelected()">
            <div class="flex-row start-center gap-8">
              <span class="ui-icon-edit select-cameras-btn-icon"></span>
              {{ 'LOCATION_LIST.MANAGE_SELECTED' | translate }}
            </div>
          </ui-button>
        </div>
        <div class="horizontal-divider"></div>
        <div class="close-wrapper flex-row center-center">
          <span class="ui-icon-close ui-icon-button no-border" (click)="clearSelectedCameras()"></span>
        </div>
      </div>
    </div>
  }
</div>
